const STATUS_LABELS = {
  nouvelle_demande: "Nouvelle demande",
  en_attente_finalisation: "En attente de finalisation client",
  confirmee: "Confirmée",
  modification_demandee: "Modification demandée",
  annulation_demandee: "Annulation demandée",
  passee: "Passée",
  refusee: "Refusée",
  annulee: "Annulée",
  expiree: "Expirée",
};

export const statusLabel = (code) => STATUS_LABELS[code] || code;

const STATUS_STYLES = {
  "Nouvelle demande": "bg-aeblue/15 text-aeblue",
  "En attente de finalisation": "bg-aeblue/15 text-aeblue",
  "En attente de finalisation client": "bg-aeblue/15 text-aeblue",
  "Confirmée": "bg-sage/20 text-deepgreen",
  "Confirmé": "bg-sage/20 text-deepgreen",
  "En attente de solde": "bg-gold/20 text-deepgreen",
  "Modification demandée": "bg-gold/20 text-deepgreen",
  "Annulation demandée": "bg-gold/20 text-deepgreen",
  "Passée": "bg-muted text-muted-foreground",
  "Annulée": "bg-red-100 text-red-700",
  "Nouveau": "bg-aeblue/15 text-aeblue",
  "En attente": "bg-gold/20 text-deepgreen",
  "Répondu": "bg-sage/20 text-deepgreen",
  "À encaisser": "bg-aeblue/15 text-aeblue",
  "À venir": "bg-muted text-muted-foreground",
  "En retard": "bg-red-100 text-red-700",
  "Encaissé": "bg-sage/20 text-deepgreen",
  "Urgent": "bg-red-100 text-red-700",
  "Important": "bg-gold/20 text-deepgreen",
  "Information": "bg-aeblue/15 text-aeblue",
  "Actif": "bg-sage/20 text-deepgreen",
  "Brouillon": "bg-muted text-muted-foreground",
  "Publié": "bg-sage/20 text-deepgreen",
  "Archivé": "bg-muted text-muted-foreground",
};

export const StatusBadge = ({ status }) => {
  const label = statusLabel(status);
  return (
    <span data-testid={`status-badge-${String(label).toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className={`inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold whitespace-nowrap ${STATUS_STYLES[label] || "bg-muted text-muted-foreground"}`}>
      {label}
    </span>
  );
};
